import { useSelector, useDispatch } from "react-redux";
import FormContainer from "components/form/FormContainer";
import { ImagesReducerActions } from "reducers/imagesReducer";
import ROUTES from "constants/Routes";

const NewImage = () => {
  const formContent = {
    header: "Add New Image",
    inputs: [
      {
        label: "File",
        fieldName: "image",
        type: "file",
        required: true,
        avatar: "image",
      },
      {
        label: "Image description",
        fieldName: "description",
        helperText: "Add a short description of this image",
      },
    ],
  };

  const dispatch = useDispatch();
  const { setNewImageData, saveNewImage } = ImagesReducerActions;
  const kit = useSelector((state) => state.auth.currentKit);
  const imageData = useSelector((state) => state.images.newImage);

  const setNewImage = (fieldName, value) => {
    dispatch(setNewImageData({ ...imageData, [fieldName]: value }));
  };

  const handleSubmit = () => {
    dispatch(saveNewImage(kit, imageData));
  };

  return (
    <FormContainer
      formContent={formContent}
      data={imageData}
      setNewData={setNewImage}
      handleSubmit={handleSubmit}
      fileUpload={true}
      listPath={`${ROUTES.SETTINGS_PREFIX}${ROUTES.IMAGES}`}
    />
  );
};

export default NewImage;
